/* eslint-disable */

import React from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import { MainLayout } from '../layouts';

import { SliceZone } from '../components';

export const query = graphql`
  query ProductsQuery($uid: String!) {
    prismic {
      products(lang: "en-us", uid: $uid) {
        _meta {
          lang
          lastPublicationDate
          type
          uid
        }
        body {
        ... on PRISMIC_ProductsBodyHerotext {
          type
            label
            primary {
              fullscreen
              large_text
              text_color
              background_color
              background_image
              display_primary_cta
              display_secondary_cta
              heading
              primary_cta_color
              primary_cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              primary_cta_text
              secondary_cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              secondary_cta_text
              subheading
              text_alignment
            }
        },
        ... on PRISMIC_ProductsBodyHerobox {
          type
            label
            fields {
              hero_box_text
              hero_box_text_icon
            }
            primary {
              fullscreen
              large_text
              text_color
              hero_background_color
              hero_background_image
              hero_box_cta_text
              hero_box_cta_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              hero_box_title
              hero_box_title_color
              hero_heading
              hero_small_heading
              hero_small_heading_icon
              hero_subheading
              hero_box_cta_scroll_to_element_id
              hero_box_cta_id
            }
        },
        ... on PRISMIC_ProductsBodyListalternatingv2 {
          type
            label
            fields {
              list_alt_image
              list_alt_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              list_alt_link_text
              list_alt_text
              list_alt_title
              list_link_color
              list_text_color
              list_title_color
            }
            primary {
              background_color
              heading
              subheading
              background_image
              heading_color
              subheading_color
              text_color
            }
        },
        ... on PRISMIC_ProductsBodyListgridv2 {
          type
            label
            primary {
              background_color
              background_image
              heading
              heading_color
              list_column_number
              list_item_alignment_position
              list_item_heading_color
              list_item_text_color
              list_item_icon_position
              list_item_icon_size
              subheading
              subheading_color
              text_color
              cta_button_text
              cta_button_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              annotation
            }
            fields {
              list_item_heading
              list_item_icon
              list_item_text
              list_item_url_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              list_item_url_text
            }
        },
        ... on PRISMIC_ProductsBodyCarouselimage {
          type
            primary {
              background_color
              background_image
              text_color
              heading
              heading_color
              subheading
              subheading_color
            }
            fields {
              image
              image_text
              image_text_color
            }
        },
        ... on PRISMIC_ProductsBodyCarouseltestimonial {
          type
            label
            primary {
              background_color
              background_image
              text_color
              heading
              heading_color
              subheading1
              subheading_color
            }
            fields {
              logo
              quote
              author
              author_details
              avatar
              link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              link_text
            }
        },
        ... on PRISMIC_ProductsBodyCarouselcards {
          type
            label
            fields {
              image
              text
              text_color
              title1
              title_color
            }
            primary {
              background_color
              background_image
              cards_per_page
              cta_button_text: cta_text
              cta_button_link: cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              heading_color
              subheading
              subheading_color
              text_color
            }
        },
        ... on PRISMIC_ProductsBodyLocations {
          type
            label
            fields {
              location_name
              location_server_name
              location_link_text
              location_link_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
            }
            primary {
              background_color
              background_image
              column_number
              heading_color
              heading
              subheading
              subheading_color
              text_color
              location_name_color
              location_server_name_color
              location_link_text_color
            }
        },
        ... on PRISMIC_ProductsBodyLogogrid {
          type
            label
            fields {
              logo
            }
            primary {
              text_color
              autoScroll
              background_color
              cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              cta_text
              heading
              heading_color
              subheading
              subheading_color
              scroll_speed
            }
        },
        ... on PRISMIC_ProductsBodyToptabbednavcards {
          type
            label
            fields {
              heading
              heading_color
              subheading
              subheading_color
              cta_link_text
              cta_link_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              card_1_image
              card_1_link_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              card_1_text
              card_1_title
              card_2_image
              card_2_link_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              card_2_text
              card_2_title
              card_3_image
              card_3_link_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              card_3_text
              card_3_title
              card_4_image
              card_4_link_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              card_4_text
              card_4_title
              card_5_image
              card_5_link_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              card_5_text
              card_5_title
              card_6_image
              card_6_link_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              card_6_text
              card_6_title
              card_7_image
              card_7_link_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              card_7_text
              card_7_title
              card_8_image
              card_8_link_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              card_8_text
              card_8_title
              card_9_image
              card_9_link_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              card_9_text
              card_9_title
              card_content_alignment
              columns
              tab_icon
              tab_label
              text_color
              title_color
              card_10_image

              card_10_link_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              card_10_text
              card_10_title
              card_11_image

              card_11_link_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              card_11_text
              card_11_title
              card_12_image

              card_12_link_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              card_12_text
              card_12_title
            }
            primary {
              background_color
              background_image
              heading
              heading_color
              subheading
              subheading_color
              text_color
            }
        },
        ... on PRISMIC_ProductsBodyToptabbednavcontent {
            type
  label
  fields {
    image
    link_color
    tab_icon
    tab_label
    text
    text_color
    title1
    title_color
    content_link_text
    link_url {
      _linkType
      ... on PRISMIC__ExternalLink {
        _linkType
        url
      }
    }
    image_position
  }
  primary {
    background_color
    heading_color
    heading
    subheading
    subheading_color
    text_color
  }

        },
        ... on PRISMIC_ProductsBodyContentblock {
          type
            label
            primary {
              target_name
              background_color
              background_image
              content
              content_text_alignment
              heading
              heading_color
              image
              subheading
              subheading_color
              text_color
              wistia_id
            }
        },
        ... on PRISMIC_ProductsBodyCardsv2 {
          type
            label
            fields {
              image
              link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              text
              text_color
              title1
              title_color
            }
            primary {
              background_color
              columns
              content_alignment
              cta_button_text
              cta_button_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              heading_color
              subheading
              subheading_color
              text_color
              background_image
            }
        },
        ... on PRISMIC_ProductsBodyCtaband {
          type
            label
            primary {
              text_color
              background_color
              cta_band
              cta_primary_background_color
              cta_text_primary
              cta_text_secondary
              cta_url_primary {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              cta_url_secondary {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              subheading
              background_image
            }
        },
        ... on PRISMIC_ProductsBodyCodeblock {
          type
  label
  primary {
    heading,
    heading_color,
    subheading,
    subheading_color
    background_color
    background_image
    copy
    copy_color
    headline
    headline_color
    code_link_url {
      ... on PRISMIC__ExternalLink {
        _linkType
        url
      }
    }
    code_link_text
    link_text
    text_color
    link_url {
      ... on PRISMIC__ExternalLink {
        _linkType
        url
      }
    }
  }
  fields {
    code_content
    code_language
  }
        },
        ... on PRISMIC_ProductsBodyResourcetable {
          
  type
  label
  primary {
    background_color
    heading
    heading_color
    subheading
    subheading_color
    text_color
  }
  fields {
    section_title
    section_subtitle
    title_1
    title_2
    title_3
    title_4
    copy_1
    copy_2
    copy_3
    copy_4
    icon_1
    icon_2
    icon_3
    icon_4
    subcopy_1
    subcopy_2
    subcopy_3
    subcopy_4
    subtitle_1
    subtitle_2
    subtitle_3
    subtitle_4
  }

        },
        ... on PRISMIC_ProductsBodyPromoband {
          type
label
primary {
  background_color
  cta_button_link {
    ... on PRISMIC__ExternalLink {
      _linkType
      url
    }
  }
  cta_button_text
  heading
  heading_color
  icon
  subheading
  subheading_color
}

        }}
        date
        description
        path
        title
        open_graph_image
      }
    }
  }
`;

const dropletPageHeroForm = {
  data: {
    body:[{
      "__typename": "PRISMIC_ProductsBodyHerobox",
      "type": "herobox",
      "label": null,
      "fields": [{
        "button_link": {
           "__typename": "PRISMIC__ExternalLink",
           "_linkType": "Link.web",
           "url": "https://cloud.digitalocean.com/registrations/google"
        },
        "button_text": "Sign up with Google",
        "icon": {
           "dimensions": {
           "width": 18,
           "height": 18
           },
           "alt": null,
           "copyright": null,
           "url": "https://prismic-io.s3.amazonaws.com/www-static/8d18ab05-0db4-4fd7-95d1-c5fbc4b83fc2_icon-google.svg"
        }
     }, {
        "button_link": {
           "__typename": "PRISMIC__ExternalLink",
           "_linkType": "Link.web",
           "url": "https://cloud.digitalocean.com/registrations/github"
        },
        "button_text": null,
        "icon": {
           "dimensions": {
           "width": 18,
           "height": 18
           },
           "alt": null,
           "copyright": null,
           "url": "https://prismic-io.s3.amazonaws.com/www-static/ae808fab-d9d7-458e-b368-05344b7ad308_icon-github.svg"
        }
     }],
      "primary": {
        "fullscreen": false,
        "large_text": true,
        "text_color": "light",
        "hero_background_color": "#0069ff",
        "hero_background_image": {
          "dimensions": {
            "width": 1600,
            "height": 800
          },
          "alt": null,
          "copyright": null,
          "url": "https://images.prismic.io/www-static/019f6b3f-5c0b-4ae0-ac3b-ca773cc3d55e_bg-droplets.svg?auto=compress,format"
        },
        "hero_box_cta_text": [{
          "type": "paragraph",
          "text": "Create account",
          "spans": []
        }],
        "hero_box_cta_url": {
          "__typename": "PRISMIC__ExternalLink",
          "_linkType": "Link.web",
          "url": "https://cloud.digitalocean.com/registrations/new"
        },
        "hero_box_title": [{
          "type": "heading5",
          "text": "Starting at $5/mo",
          "spans": []
        }],
        "hero_box_title_color": null,
        "hero_heading": [{
          "type": "heading1",
          "text": "Easy, fast, and flexible compute",
          "spans": []
        }],
        "hero_small_heading": [{
          "type": "paragraph",
          "text": "Droplets",
          "spans": []
        }],
        "hero_small_heading_icon": {
          "dimensions": {
            "width": 24,
            "height": 24
          },
          "alt": null,
          "copyright": null,
          "url": "https://images.prismic.io/www-static/547e3d57-13d9-47ff-851c-9f29e8423923_icon-droplets.svg?auto=compress,format"
        },
        "hero_subheading": [{
          "type": "heading2",
          "text": "Spin up your choice of virtual machine in just 55 seconds. Basic, General Purpose, CPU-Optimized, or Memory-Optimized configurations provide flexibility to build, test, and grow your app from startup to scale.",
          "spans": []
        }],
        "hero_box_cta_scroll_to_element_id": null,
        "hero_box_cta_id": "droplet-create-cta",
        "email_placeholder": "Email address",
        "name_placeholder": "Name",
        "password_placeholder": "Create a password",
        "submit_button_text": "Sign up with email",
        "form_title": [{
          "type": "heading1",
          "text": "Deploy in seconds",
          "spans": []
        }],
        "subscript": [{
          "type": "paragraph",
          "text": "By signing up you agree to the Terms of Service.",
          "spans": [{
          "start": 31,
          "end": 47,
          "type": "hyperlink",
          "data": {
              "link_type": "Web",
              "url": "https://www.digitalocean.com/legal/terms-of-service-agreement/"
          }
          }]
        }],
      }
    }, ]
  }
}

const dropletPage = {
  "data": {
    "prismic": {
      "products": {
        "_meta": {
          "lang": "en-us",
          "lastPublicationDate": "2021-01-13T23:45:22+0000",
          "type": "products",
          "uid": "droplets"
        },
        "body": [{
          "__typename": "PRISMIC_ProductsBodyListgridv2",
          "type": "listgridv2",
          "label": null,
          "primary": {
            "background_color": "#ffffff",
            "background_image": null,
            "heading": [{
              "type": "heading2",
              "text": "Rapidly provision one to thousands of Droplets in seconds",
              "spans": []
            }],
            "heading_color": null,
            "list_column_number": "3",
            "list_item_alignment_position": "left",
            "list_item_heading_color": null,
            "list_item_text_color": null,
            "list_item_icon_position": "top",
            "list_item_icon_size": "48",
            "subheading": [{
              "type": "paragraph",
              "text": "Get the flexibility you need to get up and going quickly. Select your Droplet plan and customize from there.",
              "spans": []
            }],
            "subheading_color": null,
            "text_color": "dark",
            "cta_button_text": null,
            "cta_button_url": null,
            "annotation": null
          },
          "fields": [{
            "list_item_heading": [{
              "type": "heading1",
              "text": "Deploy your custom image, 1-Click App, or standard distribution",
              "spans": []
            }],
            "list_item_icon": {
              "dimensions": {
                "width": 37,
                "height": 38
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/6abd74d1-b8c4-47e9-812f-db873983c4f2_deploy.svg?auto=compress,format"
            },
            "list_item_text": [{
              "type": "paragraph",
              "text": "Skip the installation and configuration and get straight to deploying your code.",
              "spans": []
            }],
            "list_item_url_link": null,
            "list_item_url_text": null
          }, {
            "list_item_heading": [{
              "type": "heading1",
              "text": "Choose a type and size",
              "spans": []
            }],
            "list_item_icon": {
              "dimensions": {
                "width": 41,
                "height": 41
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/2babb68e-6c5e-4f1a-8894-e7e96de1535f_type.svg?auto=compress,format"
            },
            "list_item_text": [{
              "type": "paragraph",
              "text": "Choose from Basic Plans that offer a mix of memory and shared vCPUs, or Performance Plans that provide dedicated hyper-threads from best-in-class Intel processors.",
              "spans": []
            }],
            "list_item_url_link": null,
            "list_item_url_text": null
          }, {
            "list_item_heading": [{
              "type": "heading1",
              "text": "Global availability",
              "spans": []
            }],
            "list_item_icon": {
              "dimensions": {
                "width": 35,
                "height": 41
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/c44fe171-df8b-4186-a0bc-73d29fbb74b2_global.svg?auto=compress,format"
            },
            "list_item_text": [{
              "type": "paragraph",
              "text": "Deploy your Droplets and get a reliable connection and flat pricing across 8 data center regions.",
              "spans": []
            }],
            "list_item_url_link": null,
            "list_item_url_text": null
          }]
        }, {
          "__typename": "PRISMIC_ProductsBodyResourcetable",
          "type": "resourcetable",
          "label": null,
          "primary": {
            "background_color": null,
            "heading": [{
              "type": "paragraph",
              "text": "Select the right resources for your workload",
              "spans": []
            }],
            "heading_color": null,
            "subheading": [{
              "type": "paragraph",
              "text": "Run your app on VMs that are precisely tuned for your use case. Here's how to choose.",
              "spans": [{
                "start": 64,
                "end": 85,
                "type": "hyperlink",
                "data": {
                  "link_type": "Web",
                  "url": "https://www.digitalocean.com/docs/droplets/resources/choose-plan/"
                }
              }]
            }],
            "subheading_color": null,
            "text_color": "dark"
          },
          "fields": [{
            "section_title": [{
              "type": "paragraph",
              "text": "SHARED CPU",
              "spans": [{
                "start": 0,
                "end": 10,
                "type": "strong"
              }]
            }],
            "section_subtitle": [{
              "type": "paragraph",
              "text": "Burstable performance from $5/mo",
              "spans": []
            }],
            "title_1": [{
              "type": "paragraph",
              "text": "Basic",
              "spans": [{
                "start": 0,
                "end": 5,
                "type": "strong"
              }]
            }],
            "title_2": null,
            "title_3": null,
            "title_4": null,
            "copy_1": [{
              "type": "paragraph",
              "text": "The most basic Droplet – a burstable portion of vCPU – along with a configurable amount of memory.",
              "spans": []
            }],
            "copy_2": null,
            "copy_3": null,
            "copy_4": null,
            "icon_1": {
              "dimensions": {
                "width": 25,
                "height": 30
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/28609ffa-d991-4143-8fff-708e4792cff4_icon-droplet-standard-54a2e24f.svg?auto=compress,format"
            },
            "icon_2": null,
            "icon_3": null,
            "icon_4": null,
            "subcopy_1": [{
              "type": "paragraph",
              "text": "Simple or bursty applications such as low traffic web servers, blogs, discussion forums, CMS, small databases, dev/test servers, microservices, and repository hosting.",
              "spans": []
            }],
            "subcopy_2": null,
            "subcopy_3": null,
            "subcopy_4": null,
            "subtitle_1": [{
              "type": "paragraph",
              "text": "DESIGNED FOR",
              "spans": []
            }],
            "subtitle_2": null,
            "subtitle_3": null,
            "subtitle_4": null
          }, {
            "section_title": [{
              "type": "paragraph",
              "text": "DEDICATED CPU",
              "spans": [{
                "start": 0,
                "end": 13,
                "type": "strong"
              }]
            }],
            "section_subtitle": [{
              "type": "paragraph",
              "text": "Consistent, fast performance from $40/mo",
              "spans": []
            }],
            "title_1": [{
              "type": "paragraph",
              "text": "General Purpose",
              "spans": [{
                "start": 0,
                "end": 15,
                "type": "strong"
              }]
            }],
            "title_2": [{
              "type": "paragraph",
              "text": "CPU-Optimized",
              "spans": [{
                "start": 0,
                "end": 13,
                "type": "strong"
              }]
            }],
            "title_3": [{
              "type": "paragraph",
              "text": "Memory-Optimized",
              "spans": [{
                "start": 0,
                "end": 16,
                "type": "strong"
              }]
            }],
            "title_4": [{
              "type": "paragraph",
              "text": "Storage-Optimized",
              "spans": [{
                "start": 0,
                "end": 17,
                "type": "strong"
              }]
            }],
            "copy_1": [{
              "type": "paragraph",
              "text": "The most popular modern Droplet, with 100% dedicated vCPU, along with a balanced 4GB of memory for each vCPU.",
              "spans": []
            }],
            "copy_2": [{
              "type": "paragraph",
              "text": "The CPU-centric Droplet, with 100% dedicated vCPU, along with a more modest 2GB of memory for each vCPU.",
              "spans": []
            }],
            "copy_3": [{
              "type": "paragraph",
              "text": "The maximum memory Droplet, with 100% dedicated vCPU, along with a generous 8GB of memory for each vCPU.",
              "spans": []
            }],
            "copy_4": [{
              "type": "paragraph",
              "text": "Droplets with large amounts of NVMe SSD storage and memory, along with 100% dedicated vCPU.",
              "spans": []
            }],
            "icon_1": {
              "dimensions": {
                "width": 25,
                "height": 30
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/a1f9fe94-fab3-45f0-ac96-4e5ffaef6153_icon-droplet-general-purpose-c2945a1b.svg?auto=compress,format"
            },
            "icon_2": {
              "dimensions": {
                "width": 25,
                "height": 30
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/755154f1-84e6-4b46-929a-1b096516473d_icon-droplet-cpu-f8a602b1.svg?auto=compress,format"
            },
            "icon_3": {
              "dimensions": {
                "width": 26,
                "height": 30
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/02a20025-6185-4051-a62a-cd05de1762a0_icon-droplet-ram-05b21bd8.svg?auto=compress,format"
            },
            "icon_4": {
              "dimensions": {
                "width": 30,
                "height": 30
              },
              "alt": null,
              "copyright": null,
              "url": "https://prismic-io.s3.amazonaws.com/www-static/8a761ab4-607c-4cdd-a7bd-974c4e7d0819_SO-droplet-icon+%283%29.svg"
            },
            "subcopy_1": [{
              "type": "paragraph",
              "text": "Critical applications such as high-traffic web servers, e-commerce sites, medium-sized databases, and enterprise Software as a Service (SaaS).",
              "spans": []
            }],
            "subcopy_2": [{
              "type": "paragraph",
              "text": "CPU-intensive applications like CI/CD, video encoding, machine learning, ad serving, batch processing, and active front-end web servers.",
              "spans": []
            }],
            "subcopy_3": [{
              "type": "paragraph",
              "text": "RAM-intensive applications like high-performance databases, in-memory caches, and real-time big data processing.",
              "spans": []
            }],
            "subcopy_4": [{
              "type": "paragraph",
              "text": "Extra large NoSQL databases (e.g. MongoDB, Elasticsearch, TimeScaleDB), monitoring software e.g. Prometheus, and other data warehouses.",
              "spans": []
            }],
            "subtitle_1": [{
              "type": "paragraph",
              "text": "DESIGNED FOR",
              "spans": []
            }],
            "subtitle_2": [{
              "type": "paragraph",
              "text": "DESIGNED FOR",
              "spans": []
            }],
            "subtitle_3": [{
              "type": "paragraph",
              "text": "DESIGNED FOR",
              "spans": []
            }],
            "subtitle_4": [{
              "type": "paragraph",
              "text": "DESIGNED FOR",
              "spans": []
            }]
          }]
        }, {
          "__typename": "PRISMIC_ProductsBodyToptabbednavcards",
          "type": "toptabbednavcards",
          "label": null,
          "fields": [{
            "heading": [{
              "type": "heading2",
              "text": "Deploy your Droplet with any of these available distributions",
              "spans": []
            }],
            "heading_color": null,
            "subheading": [{
              "type": "paragraph",
              "text": "Save time by building on the OS that suits your needs.",
              "spans": []
            }],
            "subheading_color": null,
            "cta_link_text": null,
            "cta_link_url": null,
            "card_1_image": {
              "dimensions": {
                "width": 53,
                "height": 55
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/1f67cb07-0dde-4a71-a347-ea5af62c94c3_ubuntu.svg?auto=compress,format"
            },
            "card_1_link_url": {
              "__typename": "PRISMIC__ExternalLink",
              "_linkType": "Link.web",
              "url": "https://www.digitalocean.com/products/linux-distribution/ubuntu/"
            },
            "card_1_text": [{
              "type": "paragraph",
              "text": "Ubuntu",
              "spans": []
            }],
            "card_1_title": [{
              "type": "heading1",
              "text": "",
              "spans": []
            }],
            "card_2_image": {
              "dimensions": {
                "width": 60,
                "height": 60
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/07d902e3-093f-4930-a0fc-895ed7728ebb_centOS.svg?auto=compress,format"
            },
            "card_2_link_url": {
              "__typename": "PRISMIC__ExternalLink",
              "_linkType": "Link.web",
              "url": "https://www.digitalocean.com/products/linux-distribution/centos/"
            },
            "card_2_text": [{
              "type": "paragraph",
              "text": "CentOS",
              "spans": []
            }],
            "card_2_title": null,
            "card_3_image": {
              "dimensions": {
                "width": 52,
                "height": 60
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/8e47a46d-4532-4b4c-a82e-ea54e3ce5020_Debian.svg?auto=compress,format"
            },
            "card_3_link_url": {
              "__typename": "PRISMIC__ExternalLink",
              "_linkType": "Link.web",
              "url": "https://www.digitalocean.com/products/linux-distribution/debian/"
            },
            "card_3_text": [{
              "type": "paragraph",
              "text": "Debian",
              "spans": []
            }],
            "card_3_title": null,
            "card_4_image": {
              "dimensions": {
                "width": 48,
                "height": 48
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/24d38682-d39d-44d7-aff6-618ba1f63555_Fedora.svg?auto=compress,format"
            },
            "card_4_link_url": {
              "__typename": "PRISMIC__ExternalLink",
              "_linkType": "Link.web",
              "url": "https://www.digitalocean.com/products/linux-distribution/fedora-24-x64/"
            },
            "card_4_text": [{
              "type": "paragraph",
              "text": "Fedora",
              "spans": []
            }],
            "card_4_title": null,
            "card_5_image": {
              "dimensions": {
                "width": 49,
                "height": 49
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/7fe4e266-f7c6-4764-bbee-879b4241efe0_CoreOS.svg?auto=compress,format"
            },
            "card_5_link_url": {
              "__typename": "PRISMIC__ExternalLink",
              "_linkType": "Link.web",
              "url": "https://www.digitalocean.com/products/linux-distribution/coreos/"
            },
            "card_5_text": [{
              "type": "paragraph",
              "text": "CoreOS",
              "spans": []
            }],
            "card_5_title": null,
            "card_6_image": {
              "dimensions": {
                "width": 52,
                "height": 47
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/4d392b2e-ec09-47ea-9588-75095c9a73cb_FreeBSD.svg?auto=compress,format"
            },
            "card_6_link_url": {
              "__typename": "PRISMIC__ExternalLink",
              "_linkType": "Link.web",
              "url": "https://www.digitalocean.com/products/linux-distribution/freebsd/"
            },
            "card_6_text": [{
              "type": "paragraph",
              "text": "FreeBSD",
              "spans": []
            }],
            "card_6_title": null,
            "card_7_image": null,
            "card_7_link_url": null,
            "card_7_text": null,
            "card_7_title": null,
            "card_8_image": null,
            "card_8_link_url": null,
            "card_8_text": null,
            "card_8_title": null,
            "card_9_image": null,
            "card_9_link_url": null,
            "card_9_text": null,
            "card_9_title": null,
            "card_content_alignment": "center",
            "columns": "6",
            "tab_icon": null,
            "tab_label": [{
              "type": "heading1",
              "text": "Distributions",
              "spans": []
            }],
            "text_color": null,
            "title_color": null,
            "card_10_image": null,
            "card_10_link_url": null,
            "card_10_text": null,
            "card_10_title": null,
            "card_11_image": null,
            "card_11_link_url": null,
            "card_11_text": null,
            "card_11_title": null,
            "card_12_image": null,
            "card_12_link_url": null,
            "card_12_text": null,
            "card_12_title": null
          }, {
            "heading": [{
              "type": "heading2",
              "text": "Deploy a Droplet using 1-Click Apps",
              "spans": []
            }],
            "heading_color": null,
            "subheading": [{
              "type": "paragraph",
              "text": "Save time with pre-installed software.",
              "spans": []
            }],
            "subheading_color": null,
            "cta_link_text": "View All 1-Click Apps on the Marketplace",
            "cta_link_url": {
              "__typename": "PRISMIC__ExternalLink",
              "_linkType": "Link.web",
              "url": "https://marketplace.digitalocean.com/"
            },
            "card_1_image": {
              "dimensions": {
                "width": 57,
                "height": 41
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/fc4da8a4-94b8-4229-bd09-d0f98913e264_Docker.svg?auto=compress,format"
            },
            "card_1_link_url": {
              "__typename": "PRISMIC__ExternalLink",
              "_linkType": "Link.web",
              "url": "https://marketplace.digitalocean.com/apps/docker"
            },
            "card_1_text": [{
              "type": "paragraph",
              "text": "Docker",
              "spans": []
            }],
            "card_1_title": null,
            "card_2_image": {
              "dimensions": {
                "width": 37,
                "height": 59
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/34083cd7-f458-4c04-bc38-ea7222503748_LAMP.svg?auto=compress,format"
            },
            "card_2_link_url": {
              "__typename": "PRISMIC__ExternalLink",
              "_linkType": "Link.web",
              "url": "https://marketplace.digitalocean.com/apps/lamp"
            },
            "card_2_text": [{
              "type": "paragraph",
              "text": "LAMP",
              "spans": []
            }],
            "card_2_title": null,
            "card_3_image": {
              "dimensions": {
                "width": 50,
                "height": 45
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/0abeff55-cc79-4ad3-9b1c-09cdef38c58a_LEMP.svg?auto=compress,format"
            },
            "card_3_link_url": {
              "__typename": "PRISMIC__ExternalLink",
              "_linkType": "Link.web",
              "url": "https://marketplace.digitalocean.com/apps/lemp"
            },
            "card_3_text": [{
              "type": "paragraph",
              "text": "LEMP",
              "spans": []
            }],
            "card_3_title": [{
              "type": "heading1",
              "text": "",
              "spans": []
            }],
            "card_4_image": {
              "dimensions": {
                "width": 28,
                "height": 56
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/56ef4cf9-7ea5-44b0-b3c7-507b60144dc8_MongoDB.svg?auto=compress,format"
            },
            "card_4_link_url": {
              "__typename": "PRISMIC__ExternalLink",
              "_linkType": "Link.web",
              "url": "https://marketplace.digitalocean.com/apps/mongodb"
            },
            "card_4_text": [{
              "type": "paragraph",
              "text": "MongoDB",
              "spans": []
            }],
            "card_4_title": null,
            "card_5_image": {
              "dimensions": {
                "width": 53,
                "height": 53
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/53973d08-06e8-47f9-be63-f213ec40821b_MySQL.svg?auto=compress,format"
            },
            "card_5_link_url": {
              "__typename": "PRISMIC__ExternalLink",
              "_linkType": "Link.web",
              "url": "https://marketplace.digitalocean.com/apps/mysql"
            },
            "card_5_text": [{
              "type": "paragraph",
              "text": "MySQL",
              "spans": []
            }],
            "card_5_title": null,
            "card_6_image": {
              "dimensions": {
                "width": 48,
                "height": 54
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/0d62bfd2-9bcb-4477-a104-a14897d0faa8_Node.js.svg?auto=compress,format"
            },
            "card_6_link_url": {
              "__typename": "PRISMIC__ExternalLink",
              "_linkType": "Link.web",
              "url": "https://marketplace.digitalocean.com/apps/nodejs"
            },
            "card_6_text": [{
              "type": "paragraph",
              "text": "Node.js",
              "spans": []
            }],
            "card_6_title": null,
            "card_7_image": null,
            "card_7_link_url": null,
            "card_7_text": null,
            "card_7_title": null,
            "card_8_image": null,
            "card_8_link_url": null,
            "card_8_text": null,
            "card_8_title": null,
            "card_9_image": null,
            "card_9_link_url": null,
            "card_9_text": null,
            "card_9_title": null,
            "card_content_alignment": "center",
            "columns": "6",
            "tab_icon": null,
            "tab_label": [{
              "type": "heading1",
              "text": "1-Click Apps",
              "spans": []
            }],
            "text_color": null,
            "title_color": null,
            "card_10_image": null,
            "card_10_link_url": null,
            "card_10_text": null,
            "card_10_title": null,
            "card_11_image": null,
            "card_11_link_url": null,
            "card_11_text": null,
            "card_11_title": null,
            "card_12_image": null,
            "card_12_link_url": null,
            "card_12_text": null,
            "card_12_title": null
          }, {
            "heading": [{
              "type": "heading2",
              "text": "Use your own image to deploy Droplets",
              "spans": []
            }],
            "heading_color": null,
            "subheading": [{
              "type": "paragraph",
              "text": "Want more control? Upload your own customized operating system or virtual appliance. Custom images make it simple to migrate and scale your preferred environment to the Cloud in locations around the world.",
              "spans": []
            }],
            "subheading_color": null,
            "cta_link_text": null,
            "cta_link_url": null,
            "card_1_image": {
              "dimensions": {
                "width": 39,
                "height": 40
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/c2077a40-fc58-4997-ba9b-5539fbb4a66e_control.svg?auto=compress,format"
            },
            "card_1_link_url": null,
            "card_1_text": [{
              "type": "paragraph",
              "text": "Customize the operating system that your applications execute on by using your own server image",
              "spans": []
            }],
            "card_1_title": [{
              "type": "heading1",
              "text": "Control your runtime",
              "spans": []
            }],
            "card_2_image": {
              "dimensions": {
                "width": 30,
                "height": 30
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/e99cc17e-f5c3-4c10-943a-fc70376d0b6e_reliably.svg?auto=compress,format"
            },
            "card_2_link_url": null,
            "card_2_text": [{
              "type": "paragraph",
              "text": "Easily upload and store your images on highly available cloud storage.",
              "spans": []
            }],
            "card_2_title": [{
              "type": "heading1",
              "text": "Reliably store your server images",
              "spans": []
            }],
            "card_3_image": {
              "dimensions": {
                "width": 39,
                "height": 41
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/726c67cb-364b-419c-9cb3-d82da83621d8_scale.svg?auto=compress,format"
            },
            "card_3_link_url": null,
            "card_3_text": [{
              "type": "paragraph",
              "text": "Deploy your custom images to any Droplet and easily resize as your application grows.",
              "spans": []
            }],
            "card_3_title": [{
              "type": "heading1",
              "text": "Scale your applications",
              "spans": []
            }],
            "card_4_image": {
              "dimensions": {
                "width": 40,
                "height": 36
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/45c18383-078f-470e-9c4b-f38fbd6f1bd6_automate.svg?auto=compress,format"
            },
            "card_4_link_url": null,
            "card_4_text": [{
              "type": "paragraph",
              "text": "API access to deploy a Droplet using your custom images.",
              "spans": []
            }],
            "card_4_title": [{
              "type": "heading1",
              "text": "Automate deployments",
              "spans": []
            }],
            "card_5_image": null,
            "card_5_link_url": null,
            "card_5_text": null,
            "card_5_title": null,
            "card_6_image": null,
            "card_6_link_url": null,
            "card_6_text": null,
            "card_6_title": null,
            "card_7_image": null,
            "card_7_link_url": null,
            "card_7_text": null,
            "card_7_title": null,
            "card_8_image": null,
            "card_8_link_url": null,
            "card_8_text": null,
            "card_8_title": null,
            "card_9_image": null,
            "card_9_link_url": null,
            "card_9_text": null,
            "card_9_title": null,
            "card_content_alignment": "left",
            "columns": "4",
            "tab_icon": null,
            "tab_label": [{
              "type": "heading1",
              "text": "Custom Images",
              "spans": []
            }],
            "text_color": null,
            "title_color": null,
            "card_10_image": null,
            "card_10_link_url": null,
            "card_10_text": null,
            "card_10_title": null,
            "card_11_image": null,
            "card_11_link_url": null,
            "card_11_text": null,
            "card_11_title": null,
            "card_12_image": null,
            "card_12_link_url": null,
            "card_12_text": null,
            "card_12_title": null
          }],
          "primary": {
            "background_color": "#ffffff",
            "background_image": null,
            "heading": [{
              "type": "heading2",
              "text": "",
              "spans": []
            }],
            "heading_color": null,
            "subheading": [{
              "type": "paragraph",
              "text": "",
              "spans": []
            }],
            "subheading_color": null,
            "text_color": "dark"
          }
        }, {
          "__typename": "PRISMIC_ProductsBodyContentblock",
          "type": "contentblock",
          "label": null,
          "primary": {
            "target_name": null,
            "background_color": "#ffffff",
            "background_image": null,
            "content": [{
              "type": "paragraph",
              "text": "Read the report ",
              "spans": [{
                "start": 0,
                "end": 15,
                "type": "hyperlink",
                "data": {
                  "link_type": "Web",
                  "url": "https://www.digitalocean.com/resources/cloud-performance-report/"
                }
              }]
            }],
            "content_text_alignment": "center",
            "heading": [{
              "type": "heading1",
              "text": "Industry-leading price-performance",
              "spans": []
            }],
            "heading_color": null,
            "image": {
              "dimensions": {
                "width": 870,
                "height": 235
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/46f0b508-057a-447d-9ebb-2f25764ab3f5_img-cloud-spectator-report.svg?auto=compress,format"
            },
            "subheading": [{
              "type": "paragraph",
              "text": "Cloud Spectator, an independent benchmarking firm, found that DigitalOcean delivered the best CPU performance per dollar when compared to AWS and Google. And thanks to our straightforward pricing, it’s easy to predict your monthly bill.",
              "spans": [{
                "start": 0,
                "end": 15,
                "type": "hyperlink",
                "data": {
                  "link_type": "Web",
                  "url": "https://cloudspectator.com/"
                }
              }]
            }],
            "subheading_color": null,
            "text_color": "dark",
            "wistia_id": null
          }
        }, {
          "__typename": "PRISMIC_ProductsBodyToptabbednavcontent",
          "type": "toptabbednavcontent",
          "label": null,
          "fields": [{
            "image": {
              "dimensions": {
                "width": 187,
                "height": 150
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/a36ed9a5-751e-4a4e-bc76-c127b5ffd8af_monitoring-c4c5b01f.svg?auto=compress,format"
            },
            "link_color": null,
            "tab_icon": {
              "dimensions": {
                "width": 26,
                "height": 25
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/dc91dabf-3feb-4891-9255-fa431c973b3c_monitoring.svg?auto=compress,format"
            },
            "tab_label": [{
              "type": "heading1",
              "text": "Monitoring",
              "spans": []
            }],
            "text": [{
              "type": "paragraph",
              "text": "Collect metrics on visibility, monitor Droplet performance, and receive alerts when problems arise in your infrastructure — at no additional cost.",
              "spans": []
            }],
            "text_color": null,
            "title1": [{
              "type": "heading3",
              "text": "Monitoring",
              "spans": []
            }],
            "title_color": null,
            "content_link_text": [{
              "type": "paragraph",
              "text": "Learn More",
              "spans": []
            }],
            "link_url": {
              "__typename": "PRISMIC__ExternalLink",
              "_linkType": "Link.web",
              "url": "https://www.digitalocean.com/products/monitoring/"
            },
            "image_position": "right"
          }, {
            "image": {
              "dimensions": {
                "width": 187,
                "height": 150
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/6da65bd2-9a24-4fad-bf35-23d2761aa91e_firewalls-0745d580.svg?auto=compress,format"
            },
            "link_color": null,
            "tab_icon": {
              "dimensions": {
                "width": 26,
                "height": 28
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/4b306ff8-45ba-47e5-abed-457f1d0cadf4_cloud+firewalls.svg?auto=compress,format"
            },
            "tab_label": [{
              "type": "heading1",
              "text": "Cloud Firewalls",
              "spans": []
            }],
            "text": [{
              "type": "paragraph",
              "text": "Easily secure your infrastructure and define what services are visible on your Droplets. For groups of Droplets, simply tag them and the appropriate rules are immediately applied. Cloud Firewalls are free and perfect for staging and production deployments.",
              "spans": []
            }],
            "text_color": null,
            "title1": [{
              "type": "heading3",
              "text": "Cloud Firewalls",
              "spans": []
            }],
            "title_color": null,
            "content_link_text": [{
              "type": "paragraph",
              "text": "Learn More",
              "spans": []
            }],
            "link_url": {
              "__typename": "PRISMIC__ExternalLink",
              "_linkType": "Link.web",
              "url": "https://www.digitalocean.com/products/cloud-firewalls/"
            },
            "image_position": "right"
          }, {
            "image": {
              "dimensions": {
                "width": 187,
                "height": 150
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/b0ddacd6-2888-4db2-8f2a-125342441d10_teams-66805afb.svg?auto=compress,format"
            },
            "link_color": null,
            "tab_icon": {
              "dimensions": {
                "width": 25,
                "height": 25
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/0171b078-a063-4096-8137-d70dd1bc056f_team.svg?auto=compress,format"
            },
            "tab_label": [{
              "type": "heading1",
              "text": "Team Management",
              "spans": []
            }],
            "text": [{
              "type": "paragraph",
              "text": "Enable unified collaboration to manage and scale your infrastructure and apps, with one invoice, and no shared credentials.",
              "spans": []
            }],
            "text_color": null,
            "title1": [{
              "type": "heading3",
              "text": "Team Management",
              "spans": []
            }],
            "title_color": null,
            "content_link_text": [{
              "type": "paragraph",
              "text": "Learn More",
              "spans": []
            }],
            "link_url": {
              "__typename": "PRISMIC__ExternalLink",
              "_linkType": "Link.web",
              "url": "https://www.digitalocean.com/products/teams/"
            },
            "image_position": "right"
          }, {
            "image": {
              "dimensions": {
                "width": 187,
                "height": 150
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/6dbe3d3f-02ab-4df7-8dec-1a9be3214c19_backups-40ab3991.svg?auto=compress,format"
            },
            "link_color": null,
            "tab_icon": {
              "dimensions": {
                "width": 27,
                "height": 27
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/89cd61e3-c3bd-4aef-a17f-fb76cce673c8_backups.svg?auto=compress,format"
            },
            "tab_label": [{
              "type": "heading1",
              "text": "Backups",
              "spans": []
            }],
            "text": [{
              "type": "paragraph",
              "text": "Affordable and easy-to-use automated backups built into the Droplet interface. Enabling this service on your Droplet can provide automatic, system-level backups at regular intervals, allowing you to easily revert or spin up new instances off of the created images. Pricing for backups is 20% of the cost of the virtual machine.",
              "spans": []
            }],
            "text_color": null,
            "title1": [{
              "type": "heading3",
              "text": "Backups",
              "spans": []
            }],
            "title_color": null,
            "content_link_text": [{
              "type": "paragraph",
              "text": "Learn More",
              "spans": []
            }],
            "link_url": {
              "__typename": "PRISMIC__ExternalLink",
              "_linkType": "Link.web",
              "url": "https://www.digitalocean.com/community/tutorials/understanding-digitalocean-droplet-backups"
            },
            "image_position": "right"
          }, {
            "image": {
              "dimensions": {
                "width": 187,
                "height": 150
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/d748ee04-b093-4695-af9f-a303ab5d7ef7_snapshots-737214bd.svg?auto=compress,format"
            },
            "link_color": null,
            "tab_icon": {
              "dimensions": {
                "width": 27,
                "height": 26
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/34924142-3793-4490-ac6e-0d8571215969_snapshots.svg?auto=compress,format"
            },
            "tab_label": [{
              "type": "heading1",
              "text": "Snapshots",
              "spans": []
            }],
            "text": [{
              "type": "paragraph",
              "text": "A snapshot could be taken prior to making any drastic changes to a server configuration, so that, should the changes be unsuccessful, you will have a version to revert back to. Pricing for snapshots is $0.05 per gigabyte per month.",
              "spans": []
            }],
            "text_color": null,
            "title1": [{
              "type": "heading3",
              "text": "Snapshots",
              "spans": []
            }],
            "title_color": null,
            "content_link_text": [{
              "type": "paragraph",
              "text": "Learn More",
              "spans": []
            }],
            "link_url": {
              "__typename": "PRISMIC__ExternalLink",
              "_linkType": "Link.web",
              "url": "https://www.digitalocean.com/community/tutorials/digitalocean-backups-and-snapshots-explained"
            },
            "image_position": "right"
          }],
          "primary": {
            "background_color": "#f3f5f9",
            "heading_color": null,
            "heading": [{
              "type": "heading2",
              "text": "Save hours managing your compute environment",
              "spans": []
            }],
            "subheading": [{
              "type": "paragraph",
              "text": "Our tools make it simple to collaborate, secure, monitor, and backup your Droplets.",
              "spans": []
            }],
            "subheading_color": null,
            "text_color": "dark"
          }
        }, {
          "__typename": "PRISMIC_ProductsBodyToptabbednavcontent",
          "type": "toptabbednavcontent",
          "label": null,
          "fields": [{
            "image": {
              "dimensions": {
                "width": 187,
                "height": 150
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/2e87ca0c-b6e4-47a1-905b-e15b88787b6d_block-storage-0e37025f.svg?auto=compress,format"
            },
            "link_color": "#00d7d2",
            "tab_icon": {
              "dimensions": {
                "width": 27,
                "height": 31
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/98c02916-eaa7-4a0c-915f-5394ad9b9250_block+storage.svg?auto=compress,format"
            },
            "tab_label": [{
              "type": "heading1",
              "text": "Block Storage",
              "spans": []
            }],
            "text": [{
              "type": "paragraph",
              "text": "Add more storage space to your Droplet or mix-and-match compute and storage to suit your application's needs — add $0.10 per gigabyte per month.",
              "spans": []
            }],
            "text_color": null,
            "title1": [{
              "type": "heading3",
              "text": "Block Storage",
              "spans": []
            }],
            "title_color": null,
            "content_link_text": [{
              "type": "paragraph",
              "text": "Learn More",
              "spans": []
            }],
            "link_url": {
              "__typename": "PRISMIC__ExternalLink",
              "_linkType": "Link.web",
              "url": "https://www.digitalocean.com/products/block-storage/"
            },
            "image_position": "left"
          }, {
            "image": {
              "dimensions": {
                "width": 187,
                "height": 150
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/0b93019a-54ae-4bdc-8b52-171b2380e240_spaces-7616a690.svg?auto=compress,format"
            },
            "link_color": "#00d7d2",
            "tab_icon": {
              "dimensions": {
                "width": 25,
                "height": 24
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/8a2e1fcb-fea6-4b94-8525-76a4f316e8db_spaces.svg?auto=compress,format"
            },
            "tab_label": [{
              "type": "heading1",
              "text": "Spaces",
              "spans": []
            }],
            "text": [{
              "type": "paragraph",
              "text": "Securely store and deliver any amount of data. Instantaneously create a cost-effective, scalable storage space using our drag-and-drop UI or API.",
              "spans": []
            }],
            "text_color": null,
            "title1": [{
              "type": "heading3",
              "text": "Spaces",
              "spans": []
            }],
            "title_color": null,
            "content_link_text": [{
              "type": "paragraph",
              "text": "Learn More",
              "spans": []
            }],
            "link_url": {
              "__typename": "PRISMIC__ExternalLink",
              "_linkType": "Link.web",
              "url": "https://www.digitalocean.com/products/spaces/"
            },
            "image_position": "left"
          }, {
            "image": {
              "dimensions": {
                "width": 187,
                "height": 150
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/5c19adfc-1702-4787-8738-179dbde45662_load-balancers-aec9d13b.svg?auto=compress,format"
            },
            "link_color": "#00d7d2",
            "tab_icon": {
              "dimensions": {
                "width": 21,
                "height": 31
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/abd4749f-2950-47bc-aa69-5e399ba90cdd_load+balancers.svg?auto=compress,format"
            },
            "tab_label": [{
              "type": "heading1",
              "text": "Load Balancers",
              "spans": []
            }],
            "text": [{
              "type": "paragraph",
              "text": "Load Balancers are a highly available, fully-managed service that works right out of the box and can be deployed as fast as a Droplet. Load Balancers distribute incoming traffic across your infrastructure to increase your application's availability.",
              "spans": []
            }],
            "text_color": null,
            "title1": [{
              "type": "paragraph",
              "text": "Load Balancers",
              "spans": []
            }],
            "title_color": null,
            "content_link_text": [{
              "type": "paragraph",
              "text": "Learn More",
              "spans": []
            }],
            "link_url": {
              "__typename": "PRISMIC__ExternalLink",
              "_linkType": "Link.web",
              "url": "https://www.digitalocean.com/products/load-balancer/"
            },
            "image_position": "left"
          }, {
            "image": {
              "dimensions": {
                "width": 187,
                "height": 150
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/ac25cc8f-c5d7-4e53-96ad-c6364f7137f5_floating-ips-5a2ebebe.svg?auto=compress,format"
            },
            "link_color": "#00d7d2",
            "tab_icon": {
              "dimensions": {
                "width": 27,
                "height": 26
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/873cf867-b6ce-450d-96f9-f781c54f0085_floating+ips.svg?auto=compress,format"
            },
            "tab_label": [{
              "type": "heading1",
              "text": "Floating IPs",
              "spans": []
            }],
            "text": [{
              "type": "paragraph",
              "text": "Single points of failure can be the downfall of any application. With Floating IPs, customers can associate an IP address with a different Droplet, with minimal downtime. This makes it possible to set up a standby Droplet, ready to receive your production traffic at a moment's notice.",
              "spans": []
            }],
            "text_color": null,
            "title1": [{
              "type": "paragraph",
              "text": "Floating IPs",
              "spans": []
            }],
            "title_color": null,
            "content_link_text": [{
              "type": "paragraph",
              "text": "Learn More",
              "spans": []
            }],
            "link_url": {
              "__typename": "PRISMIC__ExternalLink",
              "_linkType": "Link.web",
              "url": "https://www.digitalocean.com/community/tutorials/how-to-use-floating-ips-on-digitalocean"
            },
            "image_position": "left"
          }],
          "primary": {
            "background_color": "#031b4e",
            "heading_color": null,
            "heading": [{
              "type": "paragraph",
              "text": "We grow as fast as you do.",
              "spans": []
            }],
            "subheading": [{
              "type": "paragraph",
              "text": "Is your application expanding? Easily attach more storage and create highly available environments to meet your customers' demands.",
              "spans": []
            }],
            "subheading_color": null,
            "text_color": "light"
          }
        }, {
          "__typename": "PRISMIC_ProductsBodyCodeblock",
          "type": "codeblock",
          "label": null,
          "primary": {
            "heading": null,
            "heading_color": null,
            "subheading": null,
            "subheading_color": null,
            "background_color": null,
            "background_image": null,
            "copy": [{
              "type": "paragraph",
              "text": "Our API enables you to deploy and manage thousands of Droplets and resources in a simple, programmatic way.",
              "spans": []
            }, {
              "type": "paragraph",
              "text": "Manage your Droplets with greater flexibility using conventional HTTP requests. Take any number of actions or requests—including creating multiple Droplets, resizing, rebooting, enabling backups, and more—with curl commands or the official API wrappers. Includes OAuth support.",
              "spans": []
            }],
            "copy_color": null,
            "headline": [{
              "type": "heading2",
              "text": "Elegant API",
              "spans": []
            }],
            "headline_color": null,
            "code_link_url": null,
            "code_link_text": null,
            "link_text": [{
              "type": "paragraph",
              "text": "API Documentation",
              "spans": []
            }],
            "text_color": null,
            "link_url": {
              "__typename": "PRISMIC__ExternalLink",
              "_linkType": "Link.web",
              "url": "https://developers.digitalocean.com/documentation/"
            }
          },
          "fields": [{
            "code_content": [{
              "type": "preformatted",
              "text": "droplet = DropletKit::Droplet.new(\n  names: ['sub-01.example.com', 'sub-02.example.com'],\n  region: 'nyc3',\n  size: '1gb',\n  image: 'ubuntu-14-04-x64',\n  ipv6: true,\n  tags: [\"web\"]\n)\nclient.droplets.create_multiple(droplet)",
              "spans": []
            }],
            "code_language": "ruby"
          }, {
            "code_content": [{
              "type": "preformatted",
              "text": "curl -H \"Content-Type: application/json\" \\\n     -H \"Authorization: Bearer b7d03a6947b217efb6f3ec3bd3504582\" \\\n     -d '{\"names\":[\"sub-01.example.com\",\"sub-02.example.com\"],\"region\":\"nyc3\",\"size\":\"1gb\",\n\"image\":\"ubuntu-14-04-x64\"}' \\\n     -X POST \"https://api.digitalocean.com/v2/droplets\"",
              "spans": []
            }],
            "code_language": "curl"
          }, {
            "code_content": [{
              "type": "preformatted",
              "text": "createRequest := &godo.DropletMultiCreateRequest{\n  Names: []string{\"sub-01.example.com\",\"sub-02.example.com\"},\n  Region: \"nyc3\",\n  Size: \"1gb\",\n  Image: godo.DropletCreateImage{\n  Slug: \"ubuntu-14-04-x64\",\n  },\n  IPv6: true,\n  Tags: []string{\"web\"},\n}\n\ndroplet, _, err := client.Droplets.CreateMultiple(createRequest)",
              "spans": []
            }],
            "code_language": "go"
          }, {
            "code_content": [{
              "type": "preformatted",
              "text": "doctl compute droplet create \"sub-01.example.com\" \"sub-02.example.com\" \\\n--region nyc3 --size 1gb --image ubuntu-14-04-x64 --enable-ipv6",
              "spans": []
            }],
            "code_language": "doctl"
          }]
        }, {
          "__typename": "PRISMIC_ProductsBodyCardsv2",
          "type": "cardsv2",
          "label": null,
          "fields": [{
            "image": null,
            "link": null,
            "text": [{
              "type": "paragraph",
              "text": "We provide a 99.99% uptime SLA. If we fail to deliver, we’ll credit you for the amount of time that service was unavailable.",
              "spans": []
            }],
            "text_color": null,
            "title1": [{
              "type": "heading5",
              "text": "99.99% uptime SLA",
              "spans": []
            }],
            "title_color": null
          }, {
            "image": null,
            "link": null,
            "text": [{
              "type": "paragraph",
              "text": "Create a DNS record by entering your domain name and selecting a Droplet. Full DNS management allows you to easily control every aspect of your domain’s DNS settings.",
              "spans": []
            }],
            "text_color": null,
            "title1": [{
              "type": "heading5",
              "text": "DNS",
              "spans": []
            }],
            "title_color": null
          }, {
            "image": null,
            "link": null,
            "text": [{
              "type": "paragraph",
              "text": "Data centers located around the world mean you have the connectivity and redundancy you need to stay up and running.",
              "spans": []
            }],
            "text_color": null,
            "title1": [{
              "type": "heading5",
              "text": "Global data centers",
              "spans": []
            }],
            "title_color": null
          }, {
            "image": null,
            "link": null,
            "text": [{
              "type": "paragraph",
              "text": "Best-in-class network connectivity for speed and throughput.",
              "spans": []
            }],
            "text_color": null,
            "title1": [{
              "type": "heading5",
              "text": "40GbE",
              "spans": []
            }],
            "title_color": null
          }, {
            "image": null,
            "link": null,
            "text": [{
              "type": "paragraph",
              "text": "Locate your Droplet in the cloud with the most up-to-date version of the Internet Protocol.",
              "spans": []
            }],
            "text_color": null,
            "title1": [{
              "type": "heading5",
              "text": "IPv6",
              "spans": []
            }],
            "title_color": null
          }, {
            "image": null,
            "link": null,
            "text": [{
              "type": "paragraph",
              "text": "Enables Droplets to “talk” within the same data center. Traffic sent between Droplets across the private network will not count toward your bandwidth costs.",
              "spans": []
            }],
            "text_color": null,
            "title1": [{
              "type": "heading5",
              "text": "Private networking",
              "spans": []
            }],
            "title_color": null
          }, {
            "image": null,
            "link": null,
            "text": [{
              "type": "paragraph",
              "text": "Transfer the ownership of a snapshot to any DigitalOcean user.",
              "spans": []
            }],
            "text_color": null,
            "title1": [{
              "type": "heading5",
              "text": "Snapshot transfer",
              "spans": []
            }],
            "title_color": null
          }, {
            "image": null,
            "link": null,
            "text": [{
              "type": "paragraph",
              "text": "Add customized scripts to automate package installation during initial setup.",
              "spans": []
            }],
            "text_color": null,
            "title1": [{
              "type": "heading5",
              "text": "User data",
              "spans": []
            }],
            "title_color": null
          }, {
            "image": null,
            "link": null,
            "text": [{
              "type": "paragraph",
              "text": "Deploy multiple Droplets with a few clicks within our control panel or from the command line via our API.",
              "spans": []
            }],
            "text_color": null,
            "title1": [{
              "type": "heading5",
              "text": "Cluster deployment",
              "spans": []
            }],
            "title_color": null
          }, {
            "image": null,
            "link": null,
            "text": [{
              "type": "paragraph",
              "text": "Vertically scale your Droplet’s resources up or down based on your usage.",
              "spans": []
            }],
            "text_color": null,
            "title1": [{
              "type": "heading5",
              "text": "Resize",
              "spans": []
            }],
            "title_color": null
          }, {
            "image": null,
            "link": null,
            "text": [{
              "type": "paragraph",
              "text": "We use enterprise-grade solid state disks (SSDs) for increased storage performance.",
              "spans": []
            }],
            "text_color": null,
            "title1": [{
              "type": "heading5",
              "text": "Enterprise SSDs",
              "spans": []
            }],
            "title_color": null
          }, {
            "image": null,
            "link": null,
            "text": [{
              "type": "paragraph",
              "text": "Enterprise-grade KVM hypervisors improve network performance and security.",
              "spans": []
            }],
            "text_color": null,
            "title1": [{
              "type": "heading5",
              "text": "KVM",
              "spans": []
            }],
            "title_color": null
          }],
          "primary": {
            "background_color": "#ffffff",
            "columns": "4",
            "content_alignment": "center",
            "cta_button_text": null,
            "cta_button_url": null,
            "heading": [{
              "type": "heading1",
              "text": "Network features and additional specs",
              "spans": []
            }],
            "heading_color": null,
            "subheading": null,
            "subheading_color": null,
            "text_color": "dark",
            "background_image": null
          }
        }, {
          "__typename": "PRISMIC_ProductsBodyContentblock",
          "type": "contentblock",
          "label": null,
          "primary": {
            "target_name": null,
            "background_color": "#f3f5f9",
            "background_image": null,
            "content": null,
            "content_text_alignment": "center",
            "heading": [{
              "type": "heading1",
              "text": "Watch the webinar",
              "spans": []
            }],
            "heading_color": null,
            "image": null,
            "subheading": [{
              "type": "paragraph",
              "text": "See Droplet product manager, Karan Chhina, describe the modern Droplet.",
              "spans": []
            }],
            "subheading_color": null,
            "text_color": "dark",
            "wistia_id": "zu5juhf6ec"
          }
        }, {
          "__typename": "PRISMIC_ProductsBodyCardsv2",
          "type": "cardsv2",
          "label": null,
          "fields": [{
            "image": null,
            "link": {
              "__typename": "PRISMIC__ExternalLink",
              "_linkType": "Link.web",
              "url": "https://www.digitalocean.com/community/tutorials/how-to-automate-the-scaling-of-your-web-application-on-digitalocean-1604"
            },
            "text": [{
              "type": "paragraph",
              "text": "Tutorials",
              "spans": []
            }],
            "text_color": null,
            "title1": [{
              "type": "heading5",
              "text": "How To Automate the Scaling of Your Web Application on DigitalOcean Ubuntu Droplets  ",
              "spans": []
            }],
            "title_color": null
          }, {
            "image": null,
            "link": {
              "__typename": "PRISMIC__ExternalLink",
              "_linkType": "Link.web",
              "url": "https://www.digitalocean.com/docs/volumes/"
            },
            "text": [{
              "type": "paragraph",
              "text": "Product Docs",
              "spans": []
            }],
            "text_color": null,
            "title1": [{
              "type": "heading5",
              "text": "How to Use Block Storage on DigitalOcean",
              "spans": []
            }],
            "title_color": null
          }, {
            "image": null,
            "link": {
              "__typename": "PRISMIC__ExternalLink",
              "_linkType": "Link.web",
              "url": "https://www.digitalocean.com/docs/monitoring/"
            },
            "text": [{
              "type": "paragraph",
              "text": "Product Docs",
              "spans": []
            }],
            "text_color": null,
            "title1": [{
              "type": "heading5",
              "text": "An Introduction to DigitalOcean Monitoring",
              "spans": []
            }],
            "title_color": null
          }],
          "primary": {
            "background_color": "#f3f5f9",
            "columns": "3",
            "content_alignment": "left",
            "cta_button_text": "Check out more tutorials",
            "cta_button_url": {
              "__typename": "PRISMIC__ExternalLink",
              "_linkType": "Link.web",
              "url": "https://www.digitalocean.com/community/tutorials"
            },
            "heading": [{
              "type": "heading1",
              "text": "Do more with Droplets",
              "spans": []
            }],
            "heading_color": null,
            "subheading": [{
              "type": "paragraph",
              "text": "Discover your infrastructure's potential with the help of over a thousand easy-to-follow development and system operation tutorials.",
              "spans": []
            }],
            "subheading_color": null,
            "text_color": "dark",
            "background_image": null
          }
        }, {
          "__typename": "PRISMIC_ProductsBodyCtaband",
          "type": "ctaband",
          "label": null,
          "primary": {
            "text_color": "light",
            "background_color": "#0248ff",
            "cta_band": null,
            "cta_primary_background_color": "primary",
            "cta_text_primary": null,
            "cta_text_secondary": [{
              "type": "paragraph",
              "text": "Create your account",
              "spans": []
            }],
            "cta_url_primary": null,
            "cta_url_secondary": {
              "__typename": "PRISMIC__ExternalLink",
              "_linkType": "Link.web",
              "url": "https://cloud.digitalocean.com/registrations/new"
            },
            "heading": [{
              "type": "paragraph",
              "text": "Ready to get started?",
              "spans": []
            }],
            "subheading": [{
              "type": "paragraph",
              "text": "Spin up your choice of virtual machine in just 55 seconds.",
              "spans": []
            }],
            "background_image": {
              "dimensions": {
                "width": 1600,
                "height": 800
              },
              "alt": null,
              "copyright": null,
              "url": "https://images.prismic.io/www-static/019f6b3f-5c0b-4ae0-ac3b-ca773cc3d55e_bg-droplets.svg?auto=compress,format"
            }
          }
        }],
        "date": "2020-03-16",
        "description": "DigitalOcean Droplets are simple, scalable virtual machines. Spin up Basic, General Purpose, Memory-, or CPU-Optimized VMs in 55 seconds.",
        "path": "/products/droplets",
        "title": [{
          "type": "heading1",
          "text": "Droplets - Scalable Virtual Machines | DigitalOcean",
          "spans": []
        }],
        "open_graph_image": null
      }
    }
  },
  "pageContext": {
    "rootQuery": "\n  query ProductsQuery($uid: String!) {\n    prismic {\n      products(lang: \"en-us\", uid: $uid) {\n        _meta {\n          lang\n          lastPublicationDate\n          type\n          uid\n        }\n        body {\n        ... on PRISMIC_ProductsBodyHerotext {\n          type\n            label\n            primary {\n              fullscreen\n              large_text\n              text_color\n              background_color\n              background_image\n              display_primary_cta\n              display_secondary_cta\n              heading\n              primary_cta_color\n              primary_cta_link {\n                ... on PRISMIC__ExternalLink {\n                  _linkType\n                  url\n                }\n              }\n              primary_cta_text\n              secondary_cta_link {\n                ... on PRISMIC__ExternalLink {\n                  _linkType\n                  url\n                }\n              }\n              secondary_cta_text\n              subheading\n              text_alignment\n            }\n        },\n        ... on PRISMIC_ProductsBodyHerobox {\n          type\n            label\n            fields {\n              hero_box_text\n              hero_box_text_icon\n            }\n            primary {\n              fullscreen\n              large_text\n              text_color\n              hero_background_color\n              hero_background_image\n              hero_box_cta_text\n              hero_box_cta_url {\n                ... on PRISMIC__ExternalLink {\n                  _linkType\n                  url\n                }\n              }\n              hero_box_title\n              hero_box_title_color\n              hero_heading\n              hero_small_heading\n              hero_small_heading_icon\n              hero_subheading\n              hero_box_cta_scroll_to_element_id\n              hero_box_cta_id\n            }\n        },\n        ... on PRISMIC_ProductsBodyListalternatingv2 {\n          type\n            label\n            fields {\n              list_alt_image\n              list_alt_link {\n                ... on PRISMIC__ExternalLink {\n                  _linkType\n                  url\n                }\n              }\n              list_alt_link_text\n              list_alt_text\n              list_alt_title\n              list_link_color\n              list_text_color\n              list_title_color\n            }\n            primary {\n              background_color\n              heading\n              subheading\n              background_image\n              heading_color\n              subheading_color\n              text_color\n            }\n        },\n        ... on PRISMIC_ProductsBodyListgridv2 {\n          type\n            label\n            primary {\n              background_color\n              background_image\n              heading\n              heading_color\n              list_column_number\n              list_item_alignment_position\n              list_item_heading_color\n              list_item_text_color\n              list_item_icon_position\n              list_item_icon_size\n              subheading\n              subheading_color\n              text_color\n              cta_button_text\n              cta_button_url {\n                ... on PRISMIC__ExternalLink {\n                  _linkType\n                  url\n                }\n              }\n              annotation\n            }\n            fields {\n              list_item_heading\n              list_item_icon\n              list_item_text\n              list_item_url_link {\n                ... on PRISMIC__ExternalLink {\n                  _linkType\n                  url\n                }\n              }\n              list_item_url_text\n            }\n        },\n        ... on PRISMIC_ProductsBodyCarouselimage {\n          type\n            primary {\n              background_color\n              background_image\n              text_color\n              heading\n              heading_color\n              subheading\n              subheading_color\n            }\n            fields {\n              image\n              image_text\n              image_text_color\n            }\n        },\n        ... on PRISMIC_ProductsBodyCarouseltestimonial {\n          type\n            label\n            primary {\n              background_color\n              background_image\n              text_color\n              heading\n              heading_color\n              subheading1\n              subheading_color\n            }\n            fields {\n              logo\n              quote\n              author\n              author_details\n              avatar\n              link {\n                ... on PRISMIC__ExternalLink {\n                  _linkType\n                  url\n                }\n              }\n              link_text\n            }\n        },\n        ... on PRISMIC_ProductsBodyCarouselcards {\n          type\n            label\n            fields {\n              image\n              text\n              text_color\n              title1\n              title_color\n            }\n            primary {\n              background_color\n              background_image\n              cards_per_page\n              cta_button_text: cta_text\n              cta_button_link: cta_link {\n                ... on PRISMIC__ExternalLink {\n                  _linkType\n                  url\n                }\n              }\n              heading\n              heading_color\n              subheading\n              subheading_color\n              text_color\n            }\n        },\n        ... on PRISMIC_ProductsBodyLocations {\n          type\n            label\n            fields {\n              location_name\n              location_server_name\n              location_link_text\n              location_link_url {\n                ... on PRISMIC__ExternalLink {\n                  _linkType\n                  url\n                }\n              }\n            }\n            primary {\n              background_color\n              background_image\n              column_number\n              heading_color\n              heading\n              subheading\n              subheading_color\n              text_color\n              location_name_color\n              location_server_name_color\n              location_link_text_color\n            }\n        },\n        ... on PRISMIC_ProductsBodyLogogrid {\n          type\n            label\n            fields {\n              logo\n            }\n            primary {\n              text_color\n              autoScroll\n              background_color\n              cta_link {\n                ... on PRISMIC__ExternalLink {\n                  _linkType\n                  url\n                }\n              }\n              cta_text\n              heading\n              heading_color\n              subheading\n              subheading_color\n              scroll_speed\n            }\n        },\n        ... on PRISMIC_ProductsBodyToptabbednavcards {\n          type\n            label\n            fields {\n              heading\n              heading_color\n              subheading\n              subheading_color\n              cta_link_text\n              cta_link_url {\n                ... on PRISMIC__ExternalLink {\n                  _linkType\n                  url\n                }\n              }\n              card_1_image\n              card_1_link_url {\n                ... on PRISMIC__ExternalLink {\n                  _linkType\n                  url\n                }\n              }\n              card_1_text\n              card_1_title\n              card_2_image\n              card_2_link_url {\n                ... on PRISMIC__ExternalLink {\n                  _linkType\n                  url\n                }\n              }\n              card_2_text\n              card_2_title\n              card_3_image\n              card_3_link_url {\n                ... on PRISMIC__ExternalLink {\n                  _linkType\n                  url\n                }\n              }\n              card_3_text\n              card_3_title\n              card_4_image\n              card_4_link_url {\n                ... on PRISMIC__ExternalLink {\n                  _linkType\n                  url\n                }\n              }\n              card_4_text\n              card_4_title\n              card_5_image\n              card_5_link_url {\n                ... on PRISMIC__ExternalLink {\n                  _linkType\n                  url\n                }\n              }\n              card_5_text\n              card_5_title\n              card_6_image\n              card_6_link_url {\n                ... on PRISMIC__ExternalLink {\n                  _linkType\n                  url\n                }\n              }\n              card_6_text\n              card_6_title\n              card_7_image\n              card_7_link_url {\n                ... on PRISMIC__ExternalLink {\n                  _linkType\n                  url\n                }\n              }\n              card_7_text\n              card_7_title\n              card_8_image\n              card_8_link_url {\n                ... on PRISMIC__ExternalLink {\n                  _linkType\n                  url\n                }\n              }\n              card_8_text\n              card_8_title\n              card_9_image\n              card_9_link_url {\n                ... on PRISMIC__ExternalLink {\n                  _linkType\n                  url\n                }\n              }\n              card_9_text\n              card_9_title\n              card_content_alignment\n              columns\n              tab_icon\n              tab_label\n              text_color\n              title_color\n              card_10_image\n\n              card_10_link_url {\n                ... on PRISMIC__ExternalLink {\n                  _linkType\n                  url\n                }\n              }\n              card_10_text\n              card_10_title\n              card_11_image\n\n              card_11_link_url {\n                ... on PRISMIC__ExternalLink {\n                  _linkType\n                  url\n                }\n              }\n              card_11_text\n              card_11_title\n              card_12_image\n\n              card_12_link_url {\n                ... on PRISMIC__ExternalLink {\n                  _linkType\n                  url\n                }\n              }\n              card_12_text\n              card_12_title\n            }\n            primary {\n              background_color\n              background_image\n              heading\n              heading_color\n              subheading\n              subheading_color\n              text_color\n            }\n        },\n        ... on PRISMIC_ProductsBodyToptabbednavcontent {\n            type\n  label\n  fields {\n    image\n    link_color\n    tab_icon\n    tab_label\n    text\n    text_color\n    title1\n    title_color\n    content_link_text\n    link_url {\n      _linkType\n      ... on PRISMIC__ExternalLink {\n        _linkType\n        url\n      }\n    }\n    image_position\n  }\n  primary {\n    background_color\n    heading_color\n    heading\n    subheading\n    subheading_color\n    text_color\n  }\n\n        },\n        ... on PRISMIC_ProductsBodyContentblock {\n          type\n            label\n            primary {\n              target_name\n              background_color\n              background_image\n              content\n              content_text_alignment\n              heading\n              heading_color\n              image\n              subheading\n              subheading_color\n              text_color\n              wistia_id\n            }\n        },\n        ... on PRISMIC_ProductsBodyCardsv2 {\n          type\n            label\n            fields {\n              image\n              link {\n                ... on PRISMIC__ExternalLink {\n                  _linkType\n                  url\n                }\n              }\n              text\n              text_color\n              title1\n              title_color\n            }\n            primary {\n              background_color\n              columns\n              content_alignment\n              cta_button_text\n              cta_button_url {\n                ... on PRISMIC__ExternalLink {\n                  _linkType\n                  url\n                }\n              }\n              heading\n              heading_color\n              subheading\n              subheading_color\n              text_color\n              background_image\n            }\n        },\n        ... on PRISMIC_ProductsBodyCtaband {\n          type\n            label\n            primary {\n              text_color\n              background_color\n              cta_band\n              cta_primary_background_color\n              cta_text_primary\n              cta_text_secondary\n              cta_url_primary {\n                ... on PRISMIC__ExternalLink {\n                  _linkType\n                  url\n                }\n              }\n              cta_url_secondary {\n                ... on PRISMIC__ExternalLink {\n                  _linkType\n                  url\n                }\n              }\n              heading\n              subheading\n              background_image\n            }\n        },\n        ... on PRISMIC_ProductsBodyCodeblock {\n          type\n  label\n  primary {\n    heading,\n    heading_color,\n    subheading,\n    subheading_color\n    background_color\n    background_image\n    copy\n    copy_color\n    headline\n    headline_color\n    code_link_url {\n      ... on PRISMIC__ExternalLink {\n        _linkType\n        url\n      }\n    }\n    code_link_text\n    link_text\n    text_color\n    link_url {\n      ... on PRISMIC__ExternalLink {\n        _linkType\n        url\n      }\n    }\n  }\n  fields {\n    code_content\n    code_language\n  }\n        },\n        ... on PRISMIC_ProductsBodyResourcetable {\n          \n  type\n  label\n  primary {\n    background_color\n    heading\n    heading_color\n    subheading\n    subheading_color\n    text_color\n  }\n  fields {\n    section_title\n    section_subtitle\n    title_1\n    title_2\n    title_3\n    title_4\n    copy_1\n    copy_2\n    copy_3\n    copy_4\n    icon_1\n    icon_2\n    icon_3\n    icon_4\n    subcopy_1\n    subcopy_2\n    subcopy_3\n    subcopy_4\n    subtitle_1\n    subtitle_2\n    subtitle_3\n    subtitle_4\n  }\n\n        },\n        ... on PRISMIC_ProductsBodyPromoband {\n          type\nlabel\nprimary {\n  background_color\n  cta_button_link {\n    ... on PRISMIC__ExternalLink {\n      _linkType\n      url\n    }\n  }\n  cta_button_text\n  heading\n  heading_color\n  icon\n  subheading\n  subheading_color\n}\n\n        }}\n        date\n        description\n        path\n        title\n        open_graph_image\n      }\n    }\n  }\n",
    "id": "Xm_4UBAAACQApdIc",
    "lang": "en-us",
    "uid": "droplets",
    "type": "products",
    "alternateLanguages": [],
    "cursor": "YXJyYXljb25uZWN0aW9uOjE1",
    "paginationPreviousMeta": {
      "id": "XnFOeBIAACcAcyVx",
      "lang": "en-us",
      "uid": "spaces",
      "type": "products",
      "alternateLanguages": []
    },
    "paginationPreviousUid": "spaces",
    "paginationPreviousLang": "en-us",
    "paginationNextMeta": {
      "id": "XnAwpxAAACMApsjw",
      "lang": "en-us",
      "uid": "kubernetes",
      "type": "products",
      "alternateLanguages": []
    },
    "paginationNextUid": "kubernetes",
    "paginationNextLang": "en-us",
    "lastQueryChunkEndCursor": ""
  }
}

const Products = ({ data, location }) =>
  data.prismic.products ? (
    <MainLayout location={location} layout='products'>
    <Helmet>
      <title>{(data.prismic.products.title[0] && data.prismic.products.title[0].text) || 'DigitalOcean'}</title>
      <link rel="canonical" href={data.prismic.products.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.products.path : 'https://www.digitalocean.com' + data.prismic.products.path + '/'} />
      <meta
        name="description"
        content={
          data.prismic.products.description ||
          'Helping millions of developers easily build, test, manage, and scale applications of any size – faster than ever before.'
        }
      />
      <meta name="twitter:card" content="summary"/>
      <meta name="twitter:title" content={data.prismic.products.title[0] ? data.prismic.products.title[0].text : 'DigitalOcean'} />
      <meta name="twitter:description" content={data.prismic.products.description ? data.prismic.products.description : 'DigitalOcean'} />
      <meta name="twitter:image" property={data.prismic.products.open_graph_image ? data.prismic.products.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={data.prismic.products.description ? data.prismic.products.description : 'DigitalOcean'} />
      <meta property="og:title" content={data.prismic.products.title[0] ? data.prismic.products.title[0].text : 'DigitalOcean'} />
      <meta property="og:url" content={data.prismic.products.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.products.path : 'https://www.digitalocean.com' + data.prismic.products.path + '/'} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="600" />
      <meta property="og:image" content={data.prismic.products.open_graph_image ? data.prismic.products.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
    </Helmet>
      {location.pathname === '/products/droplets/' ? 
      (
        <>
        <SliceZone id="heroDropletForm" allSlices={dropletPageHeroForm.data.body} />
        <SliceZone allSlices={dropletPage.data.prismic.products.body} />
        </>
      ) : 
      <>
        <SliceZone allSlices={data.prismic.products.body} />
      </>
    }
    </MainLayout>
  ) : null;

Products.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Products;
